import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-8" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Mi perfil")
], -1)
const _hoisted_3 = { class: "col-4 text-right" }
const _hoisted_4 = {
  key: 0,
  class: "fas fa-user-cog"
}
const _hoisted_5 = {
  key: 1,
  class: "fas fa-arrow-left"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h6", { class: "heading-small text-muted mb-4" }, "Información del usuario", -1)
const _hoisted_7 = { class: "pl-lg-4" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-6" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = {
  key: 0,
  class: "col-lg-6"
}
const _hoisted_13 = { class: "col-lg-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_15 = { class: "pl-lg-4 d-flex w-100" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Editar ")
const _hoisted_17 = { style: {"color":"inherit"} }
const _hoisted_18 = { class: "w-100 d-flex justify-content-center" }
const _hoisted_19 = ["src"]

import { defineAsyncComponent, onMounted, ref } from "vue";
import { AxiosResponse } from "axios";
import { coreApi } from "@/conection";
import { IToken } from "@/types/store";
import { AuthModule } from "@/store/modules/Auth";
import { AlertModule } from "@/store/modules/Alert";
import { userSchema } from "@/store/schemas/user.schema";
// Components
import { Form } from "vee-validate";
import Modal from "@/components/Modal.vue";
import { FileResponse } from "@/conection/agent";
import ChangePassword from "./ChangePassword.vue";
import { FilesModule } from "@/store/modules/Files";
import { MessageFilePayload } from "vue-advanced-chat";
import FileInput from "@/components/Inputs/FileInput.vue";
import { env } from "@/config/index";
import { OutputDeviceModule } from "@/store/modules/OutputDevice";
import { mediaToUrl } from "@/util/utils";
type PayloadForm = Partial<Omit<IToken, "picture">> & {
	picture: MessageFilePayload[];
};
type UpdateResponse = {
	agent: {
		name: string;
		picture: string;
		auth: { username: string; code: string };
	};
	success: boolean;
};
// Data

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// States
const UserSettings = defineAsyncComponent(
	() => import("@/views/Pages/UserProfile/UserSettings.vue")
);

const show = ref(false);
const loading = ref(false);
const preview = ref<Partial<MessageFilePayload> | null>(null);
const showSettings = ref(false);
const user = ref<Partial<IToken>>({
	username: "",
	name: "",
});

// Methods
async function updateProfile({ picture, ...payload }: PayloadForm) {
	loading.value = true;
	let fileUploaded: AxiosResponse<FileResponse> | null = null;
	if (picture) fileUploaded = await FilesModule.uploadSingleFile(picture[0]);

	const {
		data: { agent, success },
	} = await coreApi.post<UpdateResponse>(`api/agent/update`, {
		user: {
			...payload,
			picture: fileUploaded?.data.url
				? mediaToUrl(fileUploaded.data.url, env.attachmentURL)
				: user.value.picture,
		},
	});
	loading.value = false;
	if (success) {
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: "Datos actualizados correctamente",
			type: "success",
		});

		if (env.requiredCallcenter && user.value.code != agent.auth.code)
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: "Los cambios en el call center seran reflejados al volver a iniciar sesión",
				type: "warning",
			});
		AuthModule.setUser({
			name: agent.name,
			picture: agent.picture,
			code: agent.auth.code,
			username: agent.auth.username,
		});
	} else {
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: "Algo salió mal, no se pudo actualizar la información",
			type: "error",
		});
	}
}
function freeMemory() {
	if (preview.value?.localUrl) URL.revokeObjectURL(preview.value?.localUrl);
}
function handlePreview(files?: MessageFilePayload[]) {
	show.value = true;
	if (files?.length) {
		const src = URL.createObjectURL(files[0] as any);
		preview.value = files[0];
		preview.value.localUrl = src;
	}
}
function handleViewSettings(show: boolean) {
	showSettings.value = show;
}

// mounted
onMounted(() => {
	if (OutputDeviceModule.ShowOutputDeviceSettings) {
		showSettings.value = true;
		OutputDeviceModule.setShowOutputDeviceSettings(false);
	}
	if (AuthModule.data.user) user.value = AuthModule.data.user;
	user.value.code = user.value.code ?? "";
	preview.value = {
		name: user.value.picture ?? "",
		localUrl: user.value.picture ?? "",
	};
});

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_card, null, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_tooltip, {
              content: 
							showSettings.value ? 'Volver al formulario' : 'Ajustes de usuario'
						,
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleViewSettings(!showSettings.value)), ["prevent"])),
                  class: "btn-lg",
                  href: ""
                }, [
                  (!showSettings.value)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                    : _createCommentVNode("", true),
                  (showSettings.value)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["content"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        (!showSettings.value)
          ? (_openBlock(), _createBlock(_unref(Form), {
              key: 0,
              "validation-schema": _unref(userSchema)(),
              onSubmit: _cache[1] || (_cache[1] = (e) => updateProfile(e))
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_base_input, {
                        name: "username",
                        type: "text",
                        label: "Username",
                        placeholder: "Username",
                        value: user.value.username
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_base_input, {
                        name: "name",
                        type: "text",
                        label: "Nombre",
                        placeholder: "Escribe aquí tu nombre",
                        value: user.value.name
                      }, null, 8, ["value"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    (_unref(env).requiredCallcenter)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createVNode(_component_base_input, {
                            name: "code",
                            type: "number",
                            label: "Código Call Center",
                            placeholder: "1234",
                            value: user.value.code
                          }, null, 8, ["value"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(FileInput, {
                        label: "Foto de perfil",
                        name: "picture",
                        placeholder: user.value.picture,
                        preview: "",
                        onPreview: handlePreview
                      }, null, 8, ["placeholder"])
                    ])
                  ])
                ]),
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_base_button, {
                    class: "ml-auto",
                    type: "primary",
                    "native-type": "submit",
                    loading: loading.value
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ]),
              _: 1
            }, 8, ["validation-schema"]))
          : (_openBlock(), _createBlock(_unref(UserSettings), { key: 1 })),
        (!showSettings.value)
          ? (_openBlock(), _createBlock(Modal, {
              key: 2,
              show: show.value,
              "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event))
            }, {
              header: _withCtx(() => [
                _createElementVNode("h4", _hoisted_17, _toDisplayString(preview.value?.name), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("img", {
                    class: "img-preview",
                    src: preview.value?.localUrl,
                    alt: "Preview image",
                    onLoad: freeMemory
                  }, null, 40, _hoisted_19)
                ])
              ]),
              _: 1
            }, 8, ["show"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!_unref(env).agentSipPass)
      ? (_openBlock(), _createBlock(ChangePassword, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})